<template>
    <div class="container-fluid">
        <div class="block-header">
            <bread-crumb></bread-crumb>
        </div>
        <div class="timeline-form">
            <div class="timeline-form-left">
                <div class="card">
                    <div class="body">
                        <events-timeline :eventStep="3"></events-timeline>
                    </div>
                </div>
            </div>
            <div class="timeline-form-right w-100">
                <div class="card card-top-line">
                    <div class="body">
                        <ul class="list-unstyled mb-0 payment-single-transfer">
                            <li class="mb-4">
                                <h5>Basics</h5>
                                <p>Make a good first impression: introduce your event objectives and entice people to learn more. This basic information will represent your event on your event page, on your event card, and in searches.</p>
                            </li>
                            <ValidationObserver v-slot="{ passes }">
                                <form @submit.prevent="passes(metadataDataSubmit)" id="event-form" ref="form">
                                    <li>
                                        <div class="head">
                                            <label>Tags <span class="text-danger">*</span></label>
                                            <i class="fa fa-info-circle ml-1" aria-hidden="true" v-b-tooltip.hover.html title="Enter up to five keywords that best describe your event. These tags will help with organization and discoverability."></i>
                                        </div>
                                        <ValidationProvider name="tags" rules="required" v-slot="{ errors}">
                                            <div class="form-group form-select single-multiselect" :class="{'errors': errors.length && !event.tags,'success':event.tags}">
                                                <span class="float-label">
                                                    <label for="functions">Tags</label>
                                                    <multiselect
                                                        placeholder=""
                                                        v-model="event.tags"  
                                                        :show-labels="false" 
                                                        :options="tags_options" 
                                                        :searchable="false">
                                                    </multiselect> 
                                                    <i class="fa fa-times" v-if="errors.length && !event.tags"></i>
                                                    <i class="fa fa-check" v-if="event.tags"></i>
                                                </span>
                                            </div>
                                        </ValidationProvider>
                                    </li>
                                    <li>
                                        <div class="head">
                                            <label>Event Duration <span class="text-danger">*</span></label>
                                            <i class="fa fa-info-circle ml-1" aria-hidden="true" v-b-tooltip.hover.html title="How many days will you be running your event for? You can run a event for any number of days, with a 60 day duration maximum."></i>
                                        </div>
                                        <ValidationProvider name="event_duration" rules="required" v-slot="{ errors}">
                                            <div class="form-group" :class="{'errors': errors.length && !event.event_duration,'success':event.event_duration}">
                                                <span class="float-label">
                                                    <input type="text" v-model="event.event_duration" class="form-control" id="event_duration" placeholder="Event Duration">
                                                    <label for="event_duration" class="control-label">Event Duration*</label>
                                                    <div class="line"></div>
                                                    <i class="fa fa-times" v-if="errors.length && !event.event_duration"></i>
                                                    <i class="fa fa-check" v-if="event.event_duration"></i>
                                                </span>
                                            </div>
                                        </ValidationProvider>
                                    </li>
                                    <li>
                                        <h5>Pitch Video or Image</h5>
                                        <p>Add a video or image to appear on the top of your event page. events with videos raise 2000% more than events without videos. Keep your video 2-3 minutes. <a class="no-decoration" href="#!">Learn how to make a great video.</a></p>
                                        <div class="btn-group video-img-btn" role="group" aria-label="Video or Image">
                                            <b-button class="btn-mw" size="lg" :variant="event.activeTab == 'video' ? 'primary' : 'outline-primary'" @click="activeTabIs('video')">Video</b-button>
                                            <b-button class="btn-mw" size="lg" :variant="event.activeTab == 'image' ? 'primary' : 'outline-primary'"  @click="activeTabIs('image')">Image</b-button>
                                        </div>
                                        <div class="body px-0 video-img-main">
                                            <div class="video-view" :class="{'active show': event.activeTab == 'video'}">
                                                <div class="head">
                                                    <label>Video <span class="text-danger">*</span></label>
                                                    <i class="fa fa-info-circle ml-1" aria-hidden="true" v-b-tooltip.hover.html title="How many days will you be running your event for? You can run a event for any number of days, with a 60 day duration maximum."></i>
                                                </div>
                                                <ValidationProvider name="event_video" :rules="event.activeTab == 'video' ? 'required' : ''" v-slot="{ errors}">
                                                    <div class="form-group" :class="{'errors': errors.length && !event.event_video,'success':event.event_video}">
                                                        <div class="custom-file">
                                                            <input type="hidden" name="event_video" v-model="event.event_video" accept="video/*">
                                                            <input id="file-input" type="file" accept="video/*"  class="form-control custom-file-input" ref="resetVideoFile">
                                                            <label class="custom-file-label" for="file-input"><span class="form-file-text d-block">Choose Video</span></label>
                                                            <i class="fa fa-times" v-if="errors.length && !event.event_video"></i>
                                                            <i class="fa fa-check" v-if="event.event_video"></i>
                                                        </div>
                                                    </div>
                                                    <div id="video_preview" v-if="event.isemptyVideo">
                                                        <video id="video" controls>
                                                            <source :src="event.eventVideoUrl" type="video/mp4">
                                                        </video>
                                                        <b-button @click="removeVideo">Remove Video</b-button>
                                                    </div>
                                                </ValidationProvider>
                                            </div>
                                            <div class="image-view" :class="{'active show': event.activeTab == 'image'}">
                                                <div class="head">
                                                    <label>Image <span class="text-danger">*</span></label>
                                                    <i class="fa fa-info-circle ml-1" aria-hidden="true" v-b-tooltip.hover.html title="How many days will you be running your event for? You can run a event for any number of days, with a 60 day duration maximum."></i>
                                                </div>
                                                <ValidationProvider name="pitchImgage" :rules="event.activeTab == 'image' ? 'required' : ''" v-slot="{ errors}">
                                                    <div class="form-group" :class="{'errors': errors.length && !event.pitchImgage,'success':event.pitchImgage}">
                                                        <div class="custom-file">
                                                            <input type="hidden" name="pitchImgage" v-model="event.pitchImgage" accept="image/*">
                                                            <input id="pitchImgage" type="file" accept="image/*"  class="form-control custom-file-input" ref="resetPitchInput" @change="pitchImageChange">
                                                            <label class="custom-file-label" for="pitchImgage">Choose Image</label>
                                                            <i class="fa fa-times" v-if="errors.length && !event.pitchImgage"></i>
                                                            <i class="fa fa-check" v-if="event.pitchImgage"></i>
                                                        </div>
                                                    </div>
                                                    <div id="preview_pitch" v-if="event.pitchImgage">
                                                        <img :src="event.pitchImgage"/>
                                                        <b-button @click="removePitchImage">Remove image</b-button>
                                                    </div>
                                                </ValidationProvider>
                                            </div>
                                        </div>
                                    </li>
                                    <div class="d-flex flex-column flex-md-row justify-content-center justify-content-md-end">
                                        <b-button size="lg" @click="$router.go(-1)" class="btn-mw">BACK</b-button>
                                        <b-button type="submit" variant="primary ml-md-1 mt-2 mt-md-0 btn-mw" size="lg">SAVE &amp; CONTINUE</b-button>
                                    </div>
                                </form>
                            </ValidationObserver>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
const BreadCrumb = require('@/components/BreadCrumb.vue').default
const { ValidationObserver,ValidationProvider} = require('vee-validate')
const Multiselect = require('vue-multiselect').default
const EventTimeline = require('@/components/core/EventTimeline').default
import "@/plugins/vee-validate";

export default {
    name:'EventForm4Component',
    components: {
        BreadCrumb,
        ValidationObserver,
        ValidationProvider,
        Multiselect,
        'events-timeline':EventTimeline
    },data(){
        return{
            event:{
                tags:null,
                event_duration:'',
                activeTab:'video',
                pitchImgage: null,
                event_video:null,
                isemptyVideo:false,
                eventVideoUrl:null
            },

             tags_options:[
                '3d',
                '3d printers',
                'adventure',
                'air purifiers',
                'bags'
            ]
        }
    },methods: {
        //submit form data
        metadataDataSubmit(){
            this.$router.push({ path: '/event/event-faq' })
        },

        //check which tab is active
        activeTabIs(currentTab){
            this.event.activeTab = currentTab
        },

        //remove video
        removeVideo(){
            this.$refs.resetVideoFile.value = null;
            var video = document.getElementById('video');
            video.src = "";
            this.event.isemptyVideo = false
            this.event.event_video = null;
        },

        //pitch image upload
        async pitchImageChange(e){
            if(e.target.files.length > 0){
                let file = e.target.files[0];
                this.event.pitchImgage = URL.createObjectURL(file);
                this.event.event_video = await null
                this.event.isemptyVideo = false
            }
        },

        //remove pitch image
        removePitchImage: function () {
            this.$refs.resetPitchInput.value = null;
            this.event.pitchImgage = null;
        },
    },mounted(){
        //play video
        let input = document.getElementById('file-input');
        input.addEventListener('change', (e)=> {           
            let files = e.target.files || [];
            if (!files.length) return;
            this.event.isemptyVideo = true
            this.event.eventVideoUrl =null
            this.event.event_video = null
            this.event.eventVideoUrl = URL.createObjectURL(files[0])
            this.event.event_video = files[0]
            this.event.pitchImgage = null
            let video = document.getElementById('video');
            if(video){
                video.load();
            }
        });
    }
}
</script>
